import { post } from './APIHelper';

// The API prices the unlock from LineProphet's confidence, so the client only names the game.
export const unlockGamePrediction = async ({ sport, gameId }) => {
  return post('credits/unlock-game', { sport, gameId });
};
